const constant = {
  textStyleBasic: {
    fontFamily: "Helvetica",
    fontSize: "14px",
    lineHeight: "19.6px"
  }
};

export const styleSheet: { [key: string]: React.CSSProperties } = {
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  textStyleBasic: constant.textStyleBasic,
  textStyleBold: {
    ...constant.textStyleBasic,
    fontWeight: 700,
    lineHeight: "150%"
  },
  textStyleHelper: {
    ...constant.textStyleBasic,
    fontSize: "16px",
    color: "#FF0000"
  }
};
